'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var typeStyles = {
    default: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    padding: 6px 16px;\n  "], ["\n    padding: 6px 16px;\n  "]))),
    pagination: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    padding: 8px 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "], ["\n    padding: 8px 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "]))),
};
var StyledMenuItem = styled__default.li(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: normal;\n  line-height: 22px;\n  min-height: 24px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:first-of-type {\n    margin-top: 8px;\n  }\n\n  &:last-of-type {\n    margin-bottom: 8px;\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: normal;\n  line-height: 22px;\n  min-height: 24px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:first-of-type {\n    margin-top: 8px;\n  }\n\n  &:last-of-type {\n    margin-bottom: 8px;\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryHoverGhost;
}, function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b;
    return typeStyles[type];
});
var SelectItem = React__default.forwardRef(function (_a, ref) {
    var value = _a.value, renderedValue = _a.renderedValue, _b = _a.type, type = _b === void 0 ? 'default' : _b, dataCy = _a.dataCy, restProps = tslib_es6.__rest(_a, ["value", "renderedValue", "type", "dataCy"]);
    return (React__default.createElement(StyledMenuItem, tslib_es6.__assign({ ref: ref, value: value, type: type, "data-cy": dataCy }, restProps), renderedValue));
});
SelectItem.displayName = 'SelectItem'; // needed for React to display a name for component
var templateObject_1, templateObject_2, templateObject_3;

exports.SelectItem = SelectItem;
